import React, {FC} from "react";
import {Box} from "@mui/material";
import {CheckboxGradient} from "../../../../../../../../../../../components/CheckboxGradient";
import Typography from "@mui/material/Typography";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";

const Title = styled(Typography)`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: white;
`

type PropsType = {
  title: string
  onHandleChange: (field: string, value: any, willClearField?: string | undefined) => void
  checked: boolean
  field: string
}

const CheckboxBlock: FC<PropsType> = ({
  title,
  checked,
  field,
  onHandleChange
}) => {
  const {t} = useTranslation()

  return (
    <React.Fragment>
      <Box mt={2} display='flex' justifyContent='start' alignItems={'center'}>
      <Title>{t(title)}:</Title>
        <CheckboxGradient
          style={{maxWidth: '40px'}}
          onChange={(e) => onHandleChange(field, e.target.checked)}
          checked={checked}
        />
      </Box>
    </React.Fragment>
  )
}

export default CheckboxBlock